<script lang="ts">
  import type { DistinctIdListResponse } from '../../lib/pandalytics';
  import {
    DataTable,
    DataTableHead,
    DataTableRow,
    DataTableCell,
    DataTableBody,
  } from 'svelte-materialify';
  import { createEventDispatcher, onMount } from 'svelte';
  import { link } from 'svelte-spa-router';
  import { getEventReport } from '../../lib/pandalytics';

  export let project: string;

  const dispatch = createEventDispatcher();
  let ids: DistinctIdListResponse[] = [];

  onMount(setUsers);

  async function setUsers() {
    const { result } = await getEventReport<DistinctIdListResponse[]>({
      project,
      name: 'distinctIdList',
    });

    ids = result;
    dispatch('user-count', ids.length);
  }
</script>

<DataTable>
  <DataTableHead>
    <DataTableRow>
      <DataTableCell>Id</DataTableCell>
      <DataTableCell>Name</DataTableCell>
      <DataTableCell>Email</DataTableCell>
    </DataTableRow>
  </DataTableHead>
  <DataTableBody>
    {#each ids as id}
      <DataTableRow>
        <DataTableCell>
          <a href="/project/{project}/users/distinct/{id.key}" use:link>
            {id.key}
          </a>
        </DataTableCell>
        <DataTableCell>
          {id['USER_NAME'] || 'No name!'}
        </DataTableCell>
        <DataTableCell>
          {id['USER_EMAIL'] || 'No email!'}
        </DataTableCell>
      </DataTableRow>
    {/each}
  </DataTableBody>
</DataTable>
